module.exports = __webpack_public_path__ + "media/images/icon_nav_search_black-fe0027a2e1dfe2bd56e7a65b221e658f.svg";